/* eslint-disable */
import axios from "axios";
import { auth } from "../firebase";

import { ORDER_APP_BACKEND_URL } from "../constants/order_app_backend_url";

const client = axios.create({
  baseURL: "https://foorcall.online",
  timeout: 30_000,
});

/**
 * @param {{ feature?: 'product_page'|'landing_page', status?: string, page?: number, limit?: number }} params
 */
export async function fetchAiGenerations(params = {}) {
  const currentUser = auth.currentUser;
  if (!currentUser) {
    throw new Error("يجب تسجيل الدخول أولاً.");
  }
  const idToken = await currentUser.getIdToken(true);

  const { data } = await client.get("/billing/subscription/ai-generations", {
    headers: { Authorization: `Bearer ${idToken}` },
    params: {
      feature: params.feature || undefined,
      status: params.status || undefined,
      page: params.page ?? 1,
      limit: params.limit ?? 20,
    },
  });

  return data; // { items, total, page, limit, totalPages }
}
